import { Box, Grid, LinearProgress } from '@mui/material'
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'

export function Loader(props: CircularProgressProps) {
  return <CircularProgress {...props} />
}

export function SectionLoader(props: CircularProgressProps) {
  return (
    <Grid
      container
      sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Loader {...props} />
    </Grid>
  )
}

export function OverlayLoader() {
  return (
    <Grid
      container
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: 'fixed',
        height: '100vh',
        width: '100vw',
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.3)',
      }}>
      <Loader />
    </Grid>
  )
}

export const PageLoader = () => {
  return (
    <Grid container component="main" sx={{ height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <Loader />
    </Grid>
  )
}

export function LinearLoader() {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  )
}
